import { LinkAtom, ListAtom, ListItemAtom, LogoAtom } from "../../atoms";
import { IExternalLink } from "../../interfaces/Link";
import styles from "./styles.module.scss";

interface Props {
  links: IExternalLink[];
  unstyled?: boolean;
  linked?: boolean;
}

export function ListMolecule(props: Readonly<Props>) {
  const { links } = props;

  return (
    <ListAtom linked={props.linked} unstyled={props.unstyled}>
      {links.map((item) => (
        <ListItemAtom link={props.linked} key={item.text}>
          <LinkAtom {...item} />
          {item.external === true && (
            <LogoAtom
              alt="externe link"
              className={styles.external}
              size="icon"
              src="/assets/icons/icon-link-external-v2.svg"
            />
          )}
        </ListItemAtom>
      ))}
    </ListAtom>
  );
}
